const skillsData = [
  {
    id: 5,
    label: 'LANGUAGES',
    data: [
      {
        skillname: 'JavaScript',
        percentage: '75',
      },
      {
        skillname: 'Ruby',
        percentage: '70',
      },
      {
        skillname: 'HTML5',
        percentage: '80',
      },
      {
        skillname: 'CSS3',
        percentage: '80',
      },
    ],
  },
  {
    id: 6,
    label: 'FRAMEWORKS',
    data: [
      {
        skillname: 'React.js',
        percentage: '75',
      },
      {
        skillname: 'Ruby on Rails',
        percentage: '80',
      },
      {
        skillname: 'RSpec',
        percentage: '85',
      },
      {
        skillname: 'Capybara',
        percentage: '80',
      },
    ],
  },
  {
    id: 7,
    label: 'TOOLS',
    data: [
      {
        skillname: 'Database Management',
        percentage: '80',
      },
      {
        skillname: 'API Design',
        percentage: '80',
      },
      {
        skillname: 'Version Control',
        percentage: '85',
      },
      {
        skillname: 'CLI',
        percentage: '90',
      },
    ],
  },
];

export default skillsData;
